module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Italic.13dc38ba.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Italic.eot
// module id = 2791
// module chunks = 51